import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Modal, UiCoreModule } from '@softline/ui-core';
import { Beweau } from '../../types/beweau';
import { AsyncPipe, CommonModule, DecimalPipe } from '@angular/common';

@Component({
    selector: 'soft-material-list',
    templateUrl: './material-list.component.html',
    styleUrls: ['./material-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        UiCoreModule,
        DecimalPipe,
        AsyncPipe,
    ]
})
export class MaterialListComponent implements Modal<string | null> {

  beweaus: Beweau[] = [];

  close!: (result: any) => void;

  constructor() {}

  registerCloseHandler(handler: (result: any) => void): void {
    this.close = handler
  }
}
